import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import styles from './styles.module.scss'

const Menu = ({ className, children }) => <div className={classnames(styles.menu, className)}>{children}</div>

Menu.defaultProps = {
  className: undefined,
}

Menu.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}

export default Menu
